module.exports = __webpack_public_path__ + "static/media/find_spec_3.16cc0072.svg";